const StatusBadge = ({ status }) => {
    const getStyles = () => {
        switch (status?.toLowerCase()) {
            case "excellent":
            case "clean":
            case "recommended":
            case "screening complete":
                return { bg: "#e6f9f0", color: "#1aa36f" };
            case "good":
                return { bg: "#e6f4ff", color: "#1677ff" };
            case "normal":
            case "maybe not":
            case "pending response":
                return { bg: "#fff7e6", color: "#fa8c16" };
            case "poor":
            case "flagged":
            case "unsure":
                return { bg: "#ffe6e6", color: "#ff4d4f" };
            default:
                return { bg: "#f5f5f5", color: "#595959" };
        }
    };

    const { bg, color } = getStyles();

    return (
        <span
            style={{
                backgroundColor: bg,
                color: color,
                padding: "1px 5px",
                borderRadius: "5px",
                fontSize: "9px",
                fontWeight: "500",
                display: "inline-block",
                border: `1px solid ${color}`
            }}
        >
            {status}
        </span>
    );
};

export default StatusBadge;